import { Injectable } from '@angular/core';
import { Store } from '@ngxs/store';
import { GoBack, OverrideReturnUrl, SetDefaultReturnUrl } from './navigation.actions';

@Injectable({ providedIn: 'root' })
export class NavigationViewModel {
  readonly #store: Store;

  constructor(store: Store) {
    this.#store = store;
  }

  setDefaultReturnUrl(url: string): void {
    this.#store.dispatch(new SetDefaultReturnUrl(url));
  }

  overrideReturnUrl(url: string): void {
    this.#store.dispatch(new OverrideReturnUrl(url));
  }

  goBack(): void {
    this.#store.dispatch(new GoBack());
  }
}
